import { useContext } from 'react';

import { TimeModeContext } from './context/TimeModeContext';

/**
 * The app-wide Local/UTC preference, set from the toggle beside the breadcrumbs.
 *
 * Every screen reads the same value, so a timestamp rendered in a table, a detail
 * panel or a map popup all follow the one choice. Use `useDateTimeFormat` to
 * format a date with it rather than reading `isUtc` by hand.
 */
export default function useTimeMode() {
  return useContext(TimeModeContext);
}
